var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('div',[(_vm.icon)?_c('h1',[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.main))]):_c('h1',[_c('img',{attrs:{"src":require(`@/assets/${_vm.imagem}`)}}),_vm._v(" "+_vm._s(_vm.main))])]),(_vm.sub && _vm.sub.length > 0)?_c('h2',{staticStyle:{"margin-left":"58px"}},[_vm._v(_vm._s(_vm.sub))]):_vm._e(),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }